import Broccolli from './../../Assets/images/vegetables/broccolli.webp';
import Cucumber from './../../Assets/images/vegetables/cucumber.webp';
import mushroom from './../../Assets/images/vegetables/mushroom.webp';
import  apple from "./../../Assets/images/Fruits/apple.webp";
import  beetroot from "./../../Assets/images/Fruits/beatRoot.webp";
import  cherry from "./../../Assets/images/Fruits/cherry.webp";
import  grapes from "./../../Assets/images/Fruits/grapes.webp";



  
  const VegetableData = [
    {
        id: 1231,
        title: "Broccolli",
        img: Broccolli,
        price: 60,
        rating: 4,
      },
      {
        id: 1232,
        title: "Cucumber",
        img: Cucumber,
        price: 60,
        rating: 4,
      },
      {
        id: 1233,
        title: "Mushroom",
        img: mushroom,
        price: 60,
        rating: 4,
      },
    {
      id: 1234,
      title: "Apple",
      img: apple,
      price: 60,
      rating: 4,
    },
    {
      id: 1225,
      title: "Beetroot",
      img: beetroot,
      price: 40,
      rating: 3,
    },
    {
      id: 1226,
      title: "Cherry",
      img: cherry,
      price: 150,
      rating: 4,
    },
    {
      id: 1227,
      title: "Grapes",
      img: grapes,
      price: 220,
      rating: 5,
    },
]

export default VegetableData;